module.exports = __webpack_public_path__ + "img/CK.7c22a5cf.png";